import { projectsProjectDetailHostCapability } from '@crest/module-projects/contracts/detail-host';
import { projectsProjectDetailLauncherCapability } from '@crest/module-projects/contracts/detail-launcher';
import { projectsProjectAccessDecisionCapability } from '@crest/module-projects/contracts/project-access-decision';
import { projectsProjectReferenceAccessHoldCapability, projectsProjectReferenceCapability, } from '@crest/module-projects/contracts/project-reference';
import { defineCrestModule } from '@crest/platform-contracts/modules';
import { platformOptionalFactProviderHostCapability } from '@crest/platform-contracts/hosts';
import { platformStorageObjectReferenceCapability } from '@crest/platform-contracts/storage';
import { assetsFleetCapability, assetsRegistryCapability } from './contracts/assets-asset.contract.js';
import { assetsAssistantContextCapability, assetsAssistantContextProviderId, } from './contracts/assets-assistant-context.contract.js';
import { assetsFleetAssignmentsCapability, assetsFleetOdometerCapability, } from './contracts/assets-fleet.contract.js';
import { assetsMaintenanceCapability, assetsMaintenanceReminderCapability, } from './contracts/assets-maintenance.contract.js';
import { assetsInventoryCapability, assetsInventoryCostSummariesCapability, assetsInventoryMovementsCapability, } from './contracts/assets-inventory.contract.js';
import { assetsPlacementsCapability, assetsRateSummaryContractVersion, } from './contracts/assets-placement.contract.js';
import { assetsRatesCapability } from './contracts/assets-rate.contract.js';
import { assetsWarehousesCapability } from './contracts/assets-warehouse.contract.js';
import { assetsLocationProvenanceCapability, assetsLocationReviewCapability, } from './contracts/assets-location-provenance.contract.js';
import { assetsImportCapability } from './contracts/assets-import.contract.js';
import { assetsInsuranceClaimsReadinessProviderId } from './contracts/assets-insurance-claims-readiness.contract.js';
import { assetsFinanceProfitabilityEquipmentCapability, assetsFinanceProfitabilityEquipmentProviderId, } from './contracts/assets-finance-profitability-equipment.contract.js';
export const assetsModuleManifest = defineCrestModule({
    id: 'assets',
    version: '1.0.0',
    kind: 'business',
    required: false,
    requires: ['platform', 'projects'],
    requiredCapabilities: [
        'platform.tenant-context.v1',
        'platform.module-access.v1',
        'platform.membership-directory.v1',
        'platform.storage.v1',
        platformStorageObjectReferenceCapability,
        projectsProjectReferenceCapability,
        projectsProjectReferenceAccessHoldCapability,
        projectsProjectAccessDecisionCapability,
        projectsProjectDetailHostCapability,
        projectsProjectDetailLauncherCapability,
        platformOptionalFactProviderHostCapability,
    ],
    optionalCapabilities: ['timesheets.current-project-suggestion.v1'],
    optionalCapabilityFallbacks: [{
            capability: 'timesheets.current-project-suggestion.v1',
            degradedMode: 'assets.current-project-suggestion-unavailable.v1',
        }],
    provides: [
        assetsRegistryCapability,
        assetsFleetCapability,
        assetsFleetAssignmentsCapability,
        assetsFleetOdometerCapability,
        assetsMaintenanceCapability,
        assetsMaintenanceReminderCapability,
        assetsWarehousesCapability,
        assetsInventoryCapability,
        assetsInventoryMovementsCapability,
        assetsInventoryCostSummariesCapability,
        assetsRatesCapability,
        assetsPlacementsCapability,
        assetsRateSummaryContractVersion,
        assetsLocationProvenanceCapability,
        assetsLocationReviewCapability,
        assetsImportCapability,
        assetsFinanceProfitabilityEquipmentCapability,
        assetsAssistantContextCapability,
    ],
    permissions: [
        'assets.registry.read',
        'assets.registry.manage',
        'assets.fleet.read',
        'assets.fleet.assign',
        'assets.fleet.odometer',
        'assets.maintenance.read',
        'assets.maintenance.manage',
        'assets.maintenance-reminders.prepare',
        'assets.warehouses.read',
        'assets.warehouses.manage',
        'assets.inventory.read',
        'assets.inventory.manage',
        'assets.inventory.move',
        'assets.inventory.restock',
        'assets.inventory.costs.read',
        'assets.placements.read',
        'assets.placements.manage',
        'assets.rates.read',
        'assets.rates.manage',
        'assets.rates.costs.read',
        'assets.location-observations.ingest',
        'assets.location-review.read',
        'assets.location-review.manage',
        'assets.import.read',
        'assets.import.execute',
        'assets.import.rollback',
    ],
    settings: [
        'assets.registry.configuration',
        'assets.fleet.policy',
        'assets.registry.display',
        'assets.copy.registry',
        'assets.copy.maintenance',
        'assets.inventory.configuration',
        'assets.inventory.display',
        'assets.copy.inventory',
        'assets.copy.warehouses',
        'assets.placement.configuration',
        'assets.placement.display',
        'assets.copy.placements',
        'assets.location-review.display',
        'assets.copy.location-review',
    ],
    copyCatalogs: [
        'assets.copy.registry',
        'assets.copy.maintenance',
        'assets.copy.inventory',
        'assets.copy.warehouses',
        'assets.copy.placements',
        'assets.copy.location-review',
    ],
    events: {
        publishes: [
            'assets.asset-created.v1',
            'assets.asset-updated.v1',
            'assets.asset-archived.v1',
            'assets.asset-restored.v1',
            'assets.fleet-assigned.v1',
            'assets.fleet-returned.v1',
            'assets.odometer-recorded.v1',
            'assets.odometer-flagged.v1',
            'assets.maintenance-created.v1',
            'assets.maintenance-updated.v1',
            'assets.maintenance-archived.v1',
            'assets.maintenance-restored.v1',
            'assets.maintenance-reminder-intent-requested.v1',
            'assets.warehouse-created.v1',
            'assets.warehouse-updated.v1',
            'assets.warehouse-archived.v1',
            'assets.warehouse-restored.v1',
            'assets.inventory-item-created.v1',
            'assets.inventory-item-updated.v1',
            'assets.inventory-item-archived.v1',
            'assets.inventory-item-restored.v1',
            'assets.inventory-movement-recorded.v1',
            'assets.inventory-low-stock-threshold-crossed.v1',
            'assets.inventory-project-assignment-override-recorded.v1',
            'assets.rate-version-created.v1',
            'assets.placement-placed.v1',
            'assets.placement-picked-up.v1',
            'assets.placement-project-assignment-override-recorded.v1',
            'assets.location-observation-recorded.v1',
            'assets.location-review-opened.v1',
            'assets.location-review-linked.v1',
            'assets.location-review-ignored.v1',
            'assets.location-review-resolved.v1',
            'assets.location-correction-proposals-created.v1',
        ],
        subscribes: [],
    },
    server: {
        routes: [
            { id: 'assets.routes.registry', priority: 0 },
            { id: 'assets.routes.fleet', priority: 10 },
            { id: 'assets.routes.maintenance', priority: 20 },
            { id: 'assets.routes.warehouses', priority: 30 },
            { id: 'assets.routes.inventory', priority: 40 },
            { id: 'assets.routes.placements-rates', priority: 50 },
            { id: 'assets.routes.location-provenance', priority: 55 },
        ],
        jobs: [],
        subscribers: [],
        slots: [{
                id: assetsInsuranceClaimsReadinessProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                requiredPermission: 'assets.placements.read',
                priority: 0,
            }, {
                id: assetsFinanceProfitabilityEquipmentProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                requiredPermission: 'assets.rates.costs.read',
                priority: 10,
            }, {
                id: assetsAssistantContextProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                priority: 20,
            }],
    },
    web: {
        routes: [
            { id: 'assets.web.registry', priority: 0 },
            { id: 'assets.web.inventory', priority: 10 },
            { id: 'assets.web.placements', priority: 20 },
            { id: 'assets.web.location-review', priority: 30 },
        ],
        navigation: [
            { id: 'assets.navigation.registry', priority: 65 },
            { id: 'assets.navigation.inventory', priority: 66 },
            { id: 'assets.navigation.placements', priority: 67 },
            { id: 'assets.navigation.location-review', priority: 68 },
        ],
        slots: [{
                id: 'assets.web.projects.placement-summary',
                requiredCapability: projectsProjectDetailHostCapability,
                requiredPermission: 'assets.placements.read',
                priority: 45,
            }],
    },
    mobile: { routes: [], slots: [] },
    portal: { routes: [], slots: [] },
    database: {
        schema: 'assets',
        owns: [
            'assets.asset_records',
            'assets.asset_versions',
            'assets.asset_commands',
            'assets.fleet_assignments',
            'assets.fleet_assignment_commands',
            'assets.fleet_odometer_readings',
            'assets.maintenance_records',
            'assets.maintenance_versions',
            'assets.maintenance_commands',
            'assets.maintenance_reminder_intents',
            'assets.list_assets',
            'assets.get_asset',
            'assets.list_asset_versions',
            'assets.execute_asset_command',
            'assets.list_fleet_assignments',
            'assets.execute_fleet_assignment_command',
            'assets.list_fleet_odometer_readings',
            'assets.record_fleet_odometer',
            'assets.list_maintenance_records',
            'assets.get_maintenance_record',
            'assets.list_maintenance_versions',
            'assets.execute_maintenance_command',
            'assets.request_maintenance_reminder_intents',
            'assets.warehouse_locations',
            'assets.warehouse_location_versions',
            'assets.warehouse_location_commands',
            'assets.list_warehouse_locations',
            'assets.get_warehouse_location',
            'assets.list_warehouse_location_versions',
            'assets.execute_warehouse_location_command',
            'assets.inventory_items',
            'assets.inventory_item_versions',
            'assets.inventory_item_commands',
            'assets.inventory_movements',
            'assets.inventory_movement_commands',
            'assets.list_inventory_items',
            'assets.get_inventory_item',
            'assets.list_inventory_item_versions',
            'assets.execute_inventory_item_command',
            'assets.list_inventory_movements',
            'assets.get_inventory_movement',
            'assets.execute_inventory_movement_command',
            'assets.asset_rate_versions',
            'assets.asset_rate_commands',
            'assets.asset_placements',
            'assets.asset_placement_transitions',
            'assets.asset_placement_commands',
            'assets.list_asset_rate_versions',
            'assets.get_asset_rate_version',
            'assets.execute_asset_rate_command',
            'assets.list_asset_placements',
            'assets.get_asset_placement',
            'assets.execute_asset_placement_command',
            'assets.read_project_rate_summary',
            'assets.read_inventory_cost_summary',
            'assets.location_review_items',
            'assets.location_review_assets',
            'assets.location_observations',
            'assets.location_correction_proposals',
            'assets.location_observation_commands',
            'assets.location_review_commands',
            'assets.source_location_snapshot_is_valid',
            'assets.source_asset_snapshot_is_valid',
            'assets.current_asset_reference_snapshot',
            'assets.location_review_snapshot',
            'assets.record_location_observation',
            'assets.list_location_review_items',
            'assets.get_location_review_item',
            'assets.execute_location_review_command',
            'assets.import_runs',
            'assets.import_identity_map',
            'assets.import_row_receipts',
            'assets.import_rejects',
            'assets.import_asset_target_changes',
            'assets.import_asset_target_rollbacks',
            'assets.begin_import_run',
            'assets.record_import_reject',
            'assets.record_import_receipt',
            'assets.complete_import_run',
            'assets.fail_import_run',
            'assets.mark_import_run_rolled_back',
            'assets.get_import_run',
            'assets.get_import_run_evidence',
            'assets.import_target_canonical_json_v1',
            'assets.import_target_sha256_v1',
            'assets.import_deterministic_asset_id_v1',
            'assets.import_asset_target_canonical_v1',
            'assets.import_asset_target_receipt_v1',
            'assets.import_validate_asset_target_payload_v1',
            'assets.apply_asset_import_target_v1',
            'assets.rollback_asset_import_target_v1',
            'assets.apply_operational_history_import_v1',
        ],
        readsThrough: [
            'platform.membership-directory.v1',
            'platform.storage.v1',
            platformStorageObjectReferenceCapability,
            projectsProjectReferenceCapability,
            projectsProjectReferenceAccessHoldCapability,
            projectsProjectAccessDecisionCapability,
            'timesheets.current-project-suggestion.v1',
        ],
        migrations: [
            'assets.registry_fleet_maintenance_foundation',
            'assets.warehouses_inventory_movements',
            'assets.placements_rates_reports',
            'assets.maintenance_assignment_reminders',
            'assets.location_provenance_review',
            'assets.import_reconciliation',
            'assets.import_target_writes',
            'assets.operational_history_import',
            'assets.project-reference-mutation-holds',
        ],
    },
    health: ['assets.database'],
    lifecycle: {
        initialization: { timeoutMs: 5_000, failureBehavior: 'quarantine-module' },
        resources: {
            requestConcurrency: 64,
            jobConcurrency: 0,
            queueBacklogLimit: 0,
            databaseConnectionBudget: 8,
            workerIsolation: 'shared-api',
        },
        disable: {
            data: 'retain',
            clientContributions: 'remove',
            serverRoutes: 'deny-tenant-access',
            scheduledJobs: 'skip',
            events: {
                behavior: 'drop-safe',
                durableCursor: false,
                retentionDays: 0,
                backlogLimit: 0,
                warningAt: 0,
                reconciliationProcedure: null,
                dropSafeReason: 'Assets publishes retained facts and prepares provider-neutral records, but owns no delivery subscriber or external provider worker.',
            },
            outboundSideEffects: 'suppress-no-retroactive-send',
            inFlight: 'finish-idempotently',
        },
        resume: {
            configuration: 'last-compatible-published',
            healthChecks: ['assets.database'],
            reconciliationProcedure: null,
            visibility: 'after-health-and-reconciliation',
        },
        uninstall: {
            executableCode: 'remove',
            data: 'retain',
            tombstone: 'retain-immutable',
            destruction: 'separate-explicit-authority',
        },
    },
    retentionPolicy: 'Assets, maintenance, reminders, inventory, placements, rates, location provenance, correction proposals, and replay evidence remain while disabled.',
});
//# sourceMappingURL=assets.module.js.map